// Model
import { ApiResponse } from '../models/api-response.model';
import { Announcement } from '@core/models/announcement.model';
import { Marquees, Maintenances } from '@core/models/marquees.model';
import { Popup } from '@core/models/popup.model';
// Angular
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// RxJS
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { WebsocketService } from './websocket.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementHttpService {

  newPromptIncoming = new Subject();
  newVipPromptIncoming = new Subject();

  static rewardPrompt: Announcement = null;
  static vipDialog: Announcement = null;

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private websocketService: WebsocketService,
  ) {}

  async init(memberAccountId: number) {
    this.updatePromptWebsocket(memberAccountId);
    this.updateVipDialog();
  }

  getAnnouncements(): Observable<Announcement[]> {
    return this.http.get<ApiResponse>(`/announcement`).pipe(
      map(res => res.data.rows)
    );
  }

  // slackMessage(message: string) { //commented, slack message would be replaced by spreadsheet log
  //   return this.http.post<void>('/actreport', { mes: message });
  // }

  visitLog(member_id: number) {
    return this.http.post<void>('/actreport', { member_id: member_id });
  }

  getMarquees(): Observable<Marquees[]>{
    return this.http.get<ApiResponse>(`/marquees`).pipe(
      map(res => res.data.rows)
    );
  }

  getMaintenances(): Observable<Maintenances[]>{
    return this.http.get<ApiResponse>(`/gameprovider/maintenance`).pipe(
      map(res => res.data.rows)
    );
  }

  getPopUp(dialogCode: any): Observable<Popup[]>{
    let params = '&code=';
    if (dialogCode !== null) {
      params = params + dialogCode;
    }
    else {
      params = '';
    }

    return this.http.get<ApiResponse>(`/popups?always_pop=1${params}` ).pipe(
      map(res => res.data.rows)
    );
  }

  updatePromotionPopupDialogLog(data: any): Observable<Popup[]>{
    return this.http.put<ApiResponse>(`/promotionpopupdialoglog/updateseen`, data).pipe(
      map(res => res.data.rows)
    );
  }

  private updatePromptWebsocket(memberAccountId: number) {
    this.websocketService
      .getChannel('update-reward-prompt-channel.' + memberAccountId)
      .listen(`.UpdateRewardPromptEvent`, (data) => {
        AnnouncementHttpService.rewardPrompt = data;
        this.newPromptIncoming.next();
      });
  }

  private updateVipDialog() {
    this.websocketService
      .getChannel('update-vip-dialog-channel.')
      .listen(`.UpdateVipDialogEvent`, (data) => {
        AnnouncementHttpService.vipDialog = data;
        this.newVipPromptIncoming.next();
        console.log(data, 'prompt')
      });
  }
}
